import axios from "axios";

import CarBox from "../components/carbox/CarBox";
import DesktopView from "../components/desktopview/DesktopView";
import Header from "../components/header/Header";
import globalContext from "../Contexts/GlobalContext";
import MessageModals from "../components/modals/MessageModals";
import Info from "../components/info/Info";
import PlateModal from "../components/platemodal/PlateModal";

import React, { useRef, useState, useEffect, useContext } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import BlueLoader from "../components/loader/BlueLoader";
import useRequestHeader from "../hooks/useRequestHeader";

export default function AddCar() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;

  const navigate = useNavigate();
  const contextData = useContext(globalContext);
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const requestHeader = useRequestHeader();

  const [cars, setCars] = useState([]);

  /// find car loading start///
  const [isFindCarLoading, setIsFindCarLoading] = useState(false);
  /// find car loading end///

  const addToCarsStorage = (carsList) => {
    carsList = carsList.map((car) => ({
      ...car,
      model: "",
    }));
    try {
      var localStorageCars = JSON.parse(localStorage?.getItem("cars")) || [];
      carsList?.forEach((newObject) => {
        let duplicate = localStorageCars.some(
          (item) => item.plate === newObject.plate
        );
        if (!duplicate) {
          localStorageCars.push(newObject);
        }
      });
      localStorage.setItem("cars", JSON.stringify(localStorageCars));
    } catch (e) {}
  };

  /// useeffect for check car lists start ///
  const [isLoading, setISLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  useEffect(() => {
    setISLoading(true);
    setIsLoading2(true);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(`${BASE_URL}/car/carsList`, {}, config)
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            let tmp = [];
            let B_P1 = false;
            let B_P2 = false;
            let P1 = localStorage.getItem("P1");
            let P2 = localStorage.getItem("P2");
            let t = res?.data?.Data.length;
            let k = 0;

            res?.data?.Data?.map((item) => {
              if (item?.default) {
                setHasDefault(true);
              }
              if (item.maker === "R") {
                k++;
              }
              if (P1) {
                if (item.plate === P1) {
                  B_P1 = true;
                }
              }
              if (P2) {
                if (item.plate === P2) {
                  B_P2 = true;
                }
              }
              tmp.push(item);
            });

            if (t === k) {
              contextData.setIsFirstCar(true);
            }
            if (!B_P1) {
              localStorage.setItem("P1", "");
            }
            if (!B_P2) {
              localStorage.setItem("P2", "");
            }
            setCars(tmp);

            // initilizeDB(tmp.map(({ percent, sync, ...rest }) => rest));

            // deleteDatabase()
            //   .then(() => {
            //     openDatabase(tmp.map(({ percent, sync, ...rest }) => rest));
            //   })
            //   .catch((error) => {
            //     console.error("Error:", error);
            //   });

            addToCarsStorage(tmp.map(({ percent, sync, ...rest }) => rest));
            break;
          }
          case SERVERMODE.CAR_NOT_FOUND: {
            contextData.setIsFirstCar(true);
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }

        setTimeout(() => {
          setIsLoading2(false);
        }, 500);
        setISLoading(false);
      })
      .catch((err) => {
        contextData.setIsToastOpen(true);
        contextData.setToastMessage(
          "ارتباط با سرور دچار مشکل شده است مجددا امتحان کنید"
        );
        setToastTime(3000);

        setISLoading(false);
        setIsLoading2(false);
      });
  }, []);
  //// useeffect for check car lists end ////

  const [toastTime, setToastTime] = useState(3000);
  //// registerNewCar section  strat ////
  const [newCarPlate, setNewCarPlate] = useState("");
  const registerNewCar = () => {
    if (newCarPlate.length === 9) {
      checkCarExist(newCarPlate);
    } else {
      contextData.setFireAutoF((prev) => !prev);
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("پلاک خودرو خود را وارد کنید");
      setToastTime(2000);
    }
  };
  //// registerNewCar section  end ////
  const renderCarBox = (l, gapY) => {
    let x = gapY + 1 - l;

    let content = [];
    for (let i = 0; i < x; i++) {
      content.push(
        <CarBox
          key={i}
          mode={"add"}
          percent={0}
          setNewCarPlate={setNewCarPlate}
          forwardRef={carBoxRef}
          isLoading={isLoading2}
          isPlateModalOpen={isPlateModalOpen}
          setIsPlateModalOpen={setIsPlateModalOpen}
          plateModalLetter={plateModalLetter}
          setPlateModalLetter={setPlateModalLetter}
        />
      );
    }
    return content;
  };

  //// refs section start ///
  const carBoxRef = useRef();
  const carBoxContainerRef = useRef();
  const [gapY, setGapY] = useState(0);
  useEffect(() => {
    let x =
      carBoxContainerRef?.current?.offsetHeight /
      carBoxRef?.current?.offsetHeight;
    let intX = parseInt(x) - 1;
    setGapY(intX);
  }, [gapY]);
  //// refs section end ////

  const [sortCars, setSortCars] = useState(false);
  //// useefect for sort according to pins start ////
  const [sortedCars, setSortedCars] = useState([]);
  useEffect(() => {
    // removeCookies("plate");
    contextData?.setShortErrors(0);
    contextData?.setMidErrors(0);
    contextData?.setLongErrors(0);
    let P1 = localStorage.getItem("P1");
    let P2 = localStorage.getItem("P2");
    let sortList = [];
    if (P1) {
      let arr = cars.find((item) => item.plate === P1);
      if (arr) {
        sortList.push(arr);
      }
    }
    if (P2) {
      let arr = cars.find((item) => item.plate === P2);
      if (arr) {
        sortList.push(arr);
      }
    }
    cars?.map((item1) => {
      let check = true;
      sortList?.map((item2) => {
        if (item1.plate === item2.plate) {
          check = false;
          return true;
        }
      });
      if (check) {
        sortList.push(item1);
      }
    });
    setSortedCars(sortList);

    setSortCars(false);
  }, [sortCars, cars]);

  //// useefect for sort according to pins end ////

  const [hasDefault, setHasDefault] = useState(false);
  //// default car message and bolean section start ////

  const [isPlateModalOpen, setIsPlateModalOpen] = useState(false);
  const [plateModalLetter, setPlateModalLetter] = useState("");
  const checkCarExist = (plate) => {
    setIsFindCarLoading(true);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/car/findCar`,
        {
          plate,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            if (res?.data?.Data === "true") {
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(
                "شماره پلاک وارده شده در سامانه موجود می\u200cباشد"
              );
            } else {
              contextData.setAddNewCarPlate(newCarPlate);
              navigate("/add-car-details");
            }
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
        setIsFindCarLoading(false);
      })
      .catch((err) => {
        contextData.setIsToastOpen(true);
        contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
        setIsFindCarLoading(false);
      });
  };
  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>

      <div className="w-full  min-[1024px]:hidden ">
        {contextData?.isInfoOpen && (
          <Info
            infoText={
              "کاربر عزیز شما می‌توانید در این قسمت تمامی وسایل‌نقلیه خود را با وارد نمودن شماره پلاک ثبت نمایید. درصد سلامت اقلام مصرفی و قطعات وسائل‌نقلیه شما در این قسمت نمایش داده می‌شود و شما می‌توانید حداکثر 2 خودرو را پین نموده و یک خودرو را در حالت پیش فرض قرار دهید."
            }
          />
        )}
        {isPlateModalOpen && (
          <PlateModal
            isPlateModalOpen={isPlateModalOpen}
            setIsPlateModalOpen={setIsPlateModalOpen}
            plateModalLetter={plateModalLetter}
            setPlateModalLetter={setPlateModalLetter}
          />
        )}
        <img
          src="../assets/images/body/body-bgimg.png"
          alt=""
          className="absolute h-full w-full top-0 bottom-0 left-0 right-0 -z-50"
        />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
            time={toastTime}
          />
        )}
        <Header />

        <div
          ref={carBoxContainerRef}
          className="absolute w-full top-[17.2vw]  right-0 bottom-[24.5vw] flex flex-col items-center "
        >
          <div className="relative  flex flex-col items-center justify-center">
            <div className=" w-[92.45283018867925vw] h-[19.22405660377358vw] top-[0] right-[3.773584905660377vw]  sticky">
              <svg
                width="92.45283018867925vw"
                height="19.22405660377358vw"
                viewBox="0 0 392 83"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.11857 0.646721H136.716C155.407 6.63641 175.325 9.88383 195.964 9.88383C216.639 9.88383 236.557 6.63641 255.247 0.646721H383.845C388.247 0.646721 391.855 4.25497 391.855 8.62094V74.0745C391.855 78.4765 388.247 82.0487 383.845 82.0487H8.11857C3.71651 82.0487 0.144348 78.4405 0.144348 74.0745V8.62094C0.144348 4.21888 3.75259 0.646721 8.11857 0.646721Z"
                  fill="#001D26"
                  fillOpacity="0.701961"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.11857 0.646721H136.716C155.407 6.63641 175.325 9.88383 195.964 9.88383C216.639 9.88383 236.557 6.63641 255.247 0.646721H383.845C388.247 0.646721 391.855 4.25497 391.855 8.62094V74.0745C391.855 78.4765 388.247 82.0487 383.845 82.0487H8.11857C3.71651 82.0487 0.144348 78.4405 0.144348 74.0745V8.62094C0.144348 4.21888 3.75259 0.646721 8.11857 0.646721Z"
                  stroke="#00FFF2"
                  strokeWidth="0.28866"
                  strokeMiterlimit="2.61313"
                />
              </svg>
            </div>
            <div className="w-full h-full absolute top-0 right-0 flex flex-col items-center justify-center ">
              <span className="text-[4vw] text-color-primary-D font-font_primary_A ">
                خودروهای من
              </span>
              <span className="text-[3vw] text-color-primary-D font-font_primary_A ">
                برای ثبت خودرو جدید پلاک خود را وارد نمایید
              </span>
            </div>
          </div>
          <div
            style={{ rowGap: `${1.5}vh` }}
            className="overflow-auto flex flex-col justify-between mt-[3.7vw]"
          >
            {sortedCars?.map((item) => {
              return (
                <CarBox
                  key={item.plate}
                  plate={item.plate}
                  percent={parseInt(item.percent)}
                  logoUrl={item.srcLogo}
                  repairAdd={item?.maker}
                  showModuleMode={item?.showModuleMode}
                  repairAddMessage={item.showModuleText}
                  mode={""}
                  forwardRef={carBoxRef}
                  setNewCarPlate
                  isLoading={isLoading}
                  setToastTime={setToastTime}
                  setSortCars={setSortCars}
                  isDefault={item.default ? true : false}
                  hasDefault={hasDefault}
                  setHasDefault={setHasDefault}
                  carsLength={cars.length}
                  plateModalLetter={plateModalLetter}
                  setPlateModalLetter={setPlateModalLetter}
                />
              );
            })}
            <CarBox
              mode={"add"}
              id={"inp_empty"}
              percent={0}
              setNewCarPlate={setNewCarPlate}
              forwardRef={carBoxRef}
              isLoading={isLoading2}
              isPlateModalOpen={isPlateModalOpen}
              setIsPlateModalOpen={setIsPlateModalOpen}
              plateModalLetter={plateModalLetter}
              setPlateModalLetter={setPlateModalLetter}
              checkCarExist={checkCarExist}
            />

            {sortedCars?.length + 1 <= gapY &&
              renderCarBox(cars?.length + 1, gapY)}
          </div>
        </div>

        <div className="absolute w-full flex items-center justify-center bottom-[3.681603773584906vw]">
          {isFindCarLoading ? (
            <div className="w-[92.68867924528302vw] h-[16.9811320754717vw] font-bold bg-[#001D26]  opacity-70  border-[1px] border-color-primary-D rounded-[1.886792452830189vw] flex items-center justify-center text-[#00FFF2] font-font_primary_A text-[5vw]">
              <BlueLoader position="" width={10} />
            </div>
          ) : (
            <button
              className="w-[92.68867924528302vw] h-[16.9811320754717vw] font-bold bg-[#001D26]  opacity-70  border-[1px] border-color-primary-D rounded-[1.886792452830189vw] flex items-center justify-center text-[#00FFF2] font-font_primary_A text-[5vw]"
              onClick={registerNewCar}
            >
              ثبت خودرو جدید
            </button>
          )}
        </div>
      </div>
    </>
  );
}
